"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const event_1 = require("./event");
class Component extends event_1.default {
    constructor(className) {
        super();
        this.el = document.createElement('div');
        this.getEl().className = className;
    }
    getEl() {
        return this.el;
    }
}
exports.default = Component;
